module.exports = __webpack_public_path__ + "static/media/musee.638a2748.png";